<template>
  <div class="xdeerrtts">
    <img src="../assets/img/bhjhhse.png" class="w100 dfgyuxeru">
    <div class="pd sdfdgdfteeryert">
        <div class="bgff yj4  pd pt20 pr">
            <p class="cen">
                <span class="fz16 z3 pr f_b jjnndsrtywe">{{title}}</span>
            </p>
            <div class="mt30">
                    <van-field placeholder="请输入用户名"  v-model="userName" :rules="[{ required: true }]" clearable>
                        <template slot="label">
                            <i class="f_i jjnnjxer cz"></i>
                            <span class="ml10 cz">用户名</span>
                        </template>
                    </van-field>
                    <van-field placeholder="请输入密码" type="password"  v-model="password" :rules="[{ required: true }]" clearable>
                        <template slot="label">
                            <i class="f_i jjnnjxer cz ab"></i>
                            <span class="ml10 cz">密 码</span>
                        </template>
                    </van-field>
                    <van-field placeholder="请输入验证码"  v-model="loginInput.verificationCode" :rules="[{ required: true }]"  maxlength="6" clearable>
                        <template slot="label">
                            <!-- <span class="ml10 cz">验证码</span> -->
                            <img :src="loginVerificationCode.value" style="margin-top: -4px;" @click="refreshLoginVerificationCode"/>
                        </template>
                    </van-field>
                    
            
                <div class="mt30">
                    <van-button type="primary" class="w100"  :loading="loading" @click="onClick" >{{shouldBindMember?'绑定':'登录'}}</van-button>
                    <p class="cen pt10 cen zts" v-if="!shouldBindMember"><router-link class="zts pr30"  to="/groupregist">团队注册</router-link><a class="zts pl30"  @click="onForgetPassword">忘记密码?</a></p>
                    
                </div>
            </div>

        </div>
    </div>
    <van-popup v-model="forgetPassword" duration="0" position="bottom" :style="{ height: '100%' }">
      <div class="cen pm10 mt10 notice-title">找回密码</div>
      <div class="notice-cross"><van-icon name="cross" @click="forgetPassword=false" /></div>
      <div class="pd pt10 pm10 fz14">
        <van-form @submit="onResetPassword">
          <van-field placeholder="请输入手机号" v-model="forgetInput.mobile" clearable :rules="[{ required: true }, { isMobile: mobileValidator, message: '手机号格式不正确' }]">
            <template slot="label">
                <i class="f_i jjnnjxer cz ag"></i>
                <span class="ml10 cz">手机号</span>
            </template>
          </van-field>
          <van-field placeholder="请输入验证码" v-model="forgetInput.verificationCode" clearable :maxlength="6" class="sms-code-box" :rules="[{ required: true }, { validator: smsValidator, message: '6个字符' }]">
            <template slot="label">
                <i class="f_i jjnnjxer cz ae"></i>
                <span class="ml10 cz">验证码</span>
                <van-button type="primary" size="small" native-type="button" :disabled="getVerificationCodeFlag" @click="onGetVerificationCode">
                  获取验证码
                  <van-count-down
                    v-show="getVerificationCodeFlag"
                    ref="againTimeCountDown"
                    :time="60 * 1000"
                    format="ss"
                    class="inline-countdown"
                    @finish="againTimeFinish"
                  />
                </van-button>
            </template>
          </van-field>
          <van-field type="password" placeholder="请输入新密码" v-model="forgetInput.newPassword" clearable :maxlength="12" :rules="[{ required: true }, { validator: newPasswordValidator, message: '6-12个字符，支持字母、数字及符号(不包含特殊字符)' }]">
            <template slot="label">
                <i class="f_i jjnnjxer cz ab"></i>
                <span class="ml10 cz">新密码</span>
            </template>
          </van-field>
          <van-field type="password" placeholder="请输入确认密码" v-model="forgetInput.confirmPassword" clearable :maxlength="12" :rules="[{ required: true }, { validator: confirmPasswordValidator, message: '两次输入的密码不一致' }]">
            <template slot="label">
                <i class="f_i jjnnjxer cz ab"></i>
                <span class="ml10 cz">确认密码</span>
            </template>
          </van-field>          
          <div class="mt30">
            <van-button type="primary" block :loading="loading" native-type="submit">确定</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import store from "./../store/index.js";
import appConsts from "@/store/consts.js";
const { mapActions } = createNamespacedHelpers("memberModule");
import customerService from "@/services/customerService.js";
import tokenService from "@/services/tokenService.js";
import util from "@/utils/util.js";
import validate from "@/utils/validator.js";
import { aesEncrypt } from '@/utils/crypto';

class ForgetInput {
  constructor() {
    this.mobile = "";
    this.verificationCode = "";
    this.newPassword = "";
    this.confirmPassword = "";
  }
}

export default {
  data() {
    return {
      title: "团队登录",
      loading: false,
      forgetPassword: false,
      userName: "",
      password: "",
      loginInput: {
        userName: "",
        password: "",
        verificationCode:"",
        verificationKey:""
      },
      forgetInput: new ForgetInput(),
      getVerificationCodeFlag: false,
      loginVerificationCode:{}

    };
  },
  props: {
    shouldBind: {
      type: String,
      default: "0"
    },
    nextPath: {
      type: String,
      default: ""
    },
    ticketTypeIds: {
      type: String
    },
  },
  computed: {
    shouldBindMember() {
      return this.shouldBind === "1";
    }
  },
  methods: {
    async refreshLoginVerificationCode(){
      this.loginVerificationCode = await customerService.getLoginVerificationCodeAsync();
    },
    async onClick() {
      try {
        this.loading = true;
        await this.login();
      } catch (err) {
        return;
      } finally {
        this.loading = false;
      }
    },
    async login() {
      let validateRules = [
        {
          value: this.userName,
          name: "用户名",
          rules: [
            {
              rule: "required"
            }
          ]
        },
        {
          value: this.password,
          name: "密码",
          rules: [
            {
              rule: "required"
            },
            // { 
            //   rule: "password" 
            // }
          ]
        },
        {
          value: this.loginInput.verificationCode,
          name: "验证码",
          rules: [
            {
              rule: "required"
            }
          ]
        }
      ];
      let result = validate(validateRules);
      if (!result.success) {
        this.$toast(result.message);
        return;
      }

      this.loginInput.shouldBindMember = this.shouldBindMember;
      this.loginInput.verificationKey = this.loginVerificationCode.displayText;

      this.loginInput.userName = aesEncrypt(this.userName);
      this.loginInput.password = aesEncrypt(this.password);

      try{
        let token = await customerService.loginFromWeChatAsync(this.loginInput);
        // tokenService.setToken(token.access_token);
        tokenService.setToken(token);

        await this.refreshMemberAsync();
        
        if (this.nextPath) {
          //this.$router.replace(`/${this.nextPath}?ticketTypeIds=${this.ticketTypeIds}`);
          this.$router.replace({
            name: this.nextPath,
            params: { ticketTypeIds: this.ticketTypeIds },
          });
        } else {
          this.$router.go(-1);
        }
      }
      finally{
        this.loginInput.verificationCode="";
        await this.refreshLoginVerificationCode();
      }
    },

    onForgetPassword() {
      this.clearForgetForm();
      this.forgetPassword = true;
    },
    async onGetVerificationCode() {
      const result = validate([
        {
          value: this.forgetInput.mobile,
          name: "手机号",
          rules: [{ rule: "required" }, { rule: "isMobile" }]
        }
      ]);
      if (!result.success) {
        this.$toast(result.message);
        return;
      }

      try {
        const mobile = util.encodeLoginPassword(this.forgetInput.mobile);
        await customerService.sendVerificationCodeAsync({mobile: mobile, registAreaTypeId: 1});

        this.getVerificationCodeFlag = true;
        this.$refs.againTimeCountDown.reset();
      } catch(err) {
        //
      }
    },
    againTimeFinish() {
      this.getVerificationCodeFlag = false;
    },
    smsValidator(val) {
      return /\d{6}/.test(val);
    },
    mobileValidator(val) {
      return /1\d{10}/.test(val);
    },
    newPasswordValidator(val){
      return /^[a-zA-Z0-9_-]{6,12}$/.test(val);
    },
    confirmPasswordValidator(val) {
      return this.forgetInput.newPassword == val;
    },
    onResetPassword() {
      try {
        this.loading = true;

        const input = JSON.parse(JSON.stringify(this.forgetInput));
        input.mobile = util.encodeLoginPassword(input.mobile);
        input.newPassword = util.encodeLoginPassword(input.newPassword);
        input.confirmPassword = "";
        customerService.resetPasswordAsync(input).then(res => {
          if (res && res.success) {
            this.$toast("重置密码成功");
            this.clearForgetForm();
            this.forgetPassword = false;
          } else {
            this.$toast("重置密码失败，请稍后再试");
          }
        });

        this.loading = false;
      } catch (err) {        
        this.loading = false;
      } 
    },
    clearForgetForm() {
      this.forgetInput = new ForgetInput();
    },
    ...mapActions([appConsts.refreshMemberAsync])
  },
  async created() {
    this.title = this.shouldBindMember ? "团队绑定" : "团队登录";
    window.document.title = this.title;
    store.commit(appConsts.setTitle, this.title);
    await this.refreshLoginVerificationCode();
  }
};
</script>

<style lang="scss">
.sms-code-box {
  position: relative;
  .van-button {
    position: absolute;
    right: 0px;
    top: 7px;
    font-size: 12px;
    width: 120px;
    z-index: 1;
    .van-button__text {
      display: flex;
      justify-items: center;
      line-height: 30px;
      .inline-countdown {
        color: #fff;
        padding-left: 5px;
        font-size: 12px;
        line-height: 30px;
      }
    }
  }
  .van-field__control {
    width: calc(100% - 140px);
  }
}
</style>